// GA4 event tracking
export const trackFormSubmission = (formType, metadata = {}) => {
  if (window.gtag) {
    window.gtag('event', 'form_submission', {
      form_type: formType,
      timestamp: new Date().toISOString(),
      ...metadata,
    });
  }
};

export const trackCtaClick = (ctaLabel, location) => {
  if (window.gtag) {
    window.gtag('event', 'cta_click', {
      cta_label: ctaLabel,
      cta_location: location,
      timestamp: new Date().toISOString(),
    });
  }
};

export const trackLeadCapture = (offerType) => {
  if (window.gtag) {
    window.gtag('event', 'lead_capture', {
      offer_type: offerType,
      timestamp: new Date().toISOString(),
    });
  }
};

// Google Ads conversion tracking
export const trackConversion = (conversionLabel, value = 0, currency = 'GBP') => {
  if (window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: conversionLabel, // Format: AW-XXXXXXXXXX/label-abcd1234
      value,
      currency,
      transaction_id: `lead_${Date.now()}_${Math.random()}`,
    });
  }
};

// Page view tracking (auto-handled by gatsby-plugin-google-gtag)
// Scroll depth tracking (requires gtag config enhancement)
export const enableScrollDepthTracking = () => {
  let maxScroll = 0;
  window.addEventListener('scroll', () => {
    const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
    if (scrollPercent > maxScroll) {
      maxScroll = scrollPercent;
      if ([25, 50, 75, 100].includes(Math.round(scrollPercent))) {
        if (window.gtag) {
          window.gtag('event', 'scroll_depth', {
            scroll_percent: Math.round(scrollPercent),
          });
        }
      }
    }
  });
};